import { createSlice } from "@reduxjs/toolkit";
import { fetchResignationNotices } from "./resignationsThunks";

const initialState = {
  items: [],
  page: 1,
  size: 10,
  count: 0,
  hasNext: false,
  hasPrev: false,
  totalPages: 0,
  loading: false,
  error: null,
};

const resignationsSlice = createSlice({
  name: "resignations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchResignationNotices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResignationNotices.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items || [];
        state.page = action.payload.page;
        state.size = action.payload.size;
        state.count = action.payload.count;
        state.hasNext = action.payload.hasNext;
        state.hasPrev = action.payload.hasPrev;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchResignationNotices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default resignationsSlice.reducer;
